//
//  DocumentationLegacyPageBlockColumn.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockColumn extends DocumentationLegacyPageBlock {
}
